import { render, staticRenderFns } from "./QuizDashborad.vue?vue&type=template&id=045ae946&scoped=true&"
import script from "./QuizDashborad.vue?vue&type=script&lang=js&"
export * from "./QuizDashborad.vue?vue&type=script&lang=js&"
import style0 from "./QuizDashborad.vue?vue&type=style&index=0&id=045ae946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ae946",
  null
  
)

export default component.exports